import { render } from "./ViewProjectNav.vue?vue&type=template&id=4ffef205&scoped=true"
import script from "./ViewProjectNav.vue?vue&type=script&lang=js"
export * from "./ViewProjectNav.vue?vue&type=script&lang=js"

import "./ViewProjectNav.vue?vue&type=style&index=0&id=4ffef205&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffef205"]])

export default __exports__